import { useFormContext } from 'react-hook-form'

import { useOnboardingContext } from './OnboardingContext'

import { Card, CardContentContainer } from './Card'
import styles from './Onboarding.module.css'

const OnboardingStepTwo = (props) => {
  // props
  const { onCardSelect } = props

  // context
  const { state } = useOnboardingContext()
  const { goals } = state

  // forms
  const { watch } = useFormContext()
  const currentStepId = watch('currentStepId')

  const handleCardSelection = (item) => {
    const data = { ...item }
    data.selected = !data.selected
    onCardSelect(data)
  }

  return (
    <CardContentContainer dataSource={goals}>
      {goals &&
        goals.length > 0 &&
        goals.map((data) => {
          return <Card key={data.id} stepId={currentStepId} data={data} onSelectCard={handleCardSelection} />
        })}
      {(!goals || goals.length === 0) && <label className={styles.NoRecordsFound}> Oops! Records not found </label>}
    </CardContentContainer>
  )
}

export default OnboardingStepTwo
